import React from 'react';
import UserList from './UserList';

function Friends() {
    
    return (
        <div>
            <fieldset>
                <legend>Application</legend>
                <UserList />
            </fieldset>
        </div>
    );
}

export default Friends;